import type { Testimonial } from '../types/content';

// Owner-supplied, verified testimonials only. Wording and attribution must be preserved exactly.
// The section is not rendered while this list is empty.
export const testimonials: Testimonial[] = [];
